<template>
  <div class="testimonial-wrap ptb-100 bg-albastor">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div class="section-title style4 text-center mb-40">
            <span>Testimonials</span>
            <h2>Read Our Medical Clinic Clients Reviews Discovered For You</h2>
          </div>
        </div>
      </div>

      <Carousel
        :autoplay="5000"
        :wrap-around="true"
        :breakpoints="breakpoints"
        pause-autoplay-on-hover
        class="testimonial-slider-three"
      >
        <Slide v-for="testimonial in testimonials" :key="testimonial.id">
          <div class="testimonial-card style4">
            <div class="client-img">
              <img :src="testimonial.image" alt="Image" />
              <span class="quote-icon">
                <i class="flaticon-quote-1"></i>
              </span>
            </div>
            <div class="client-info-wrap">
              <p class="client-quote">
                {{ testimonial.shortDesc }}
              </p>
              <div class="client-info">
                <h3>{{ testimonial.name }}</h3>
                <span>{{ testimonial.designation }}</span>
              </div>
            </div>
          </div>
        </Slide>

        <template #addons>
          <Pagination />
        </template>
      </Carousel>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Carousel, Slide, Pagination } from "vue3-carousel";

export default defineComponent({
  name: "OurTestimonials",
  components: {
    Carousel,
    Slide,
    Pagination,
  },
  data: () => ({
    settings: {
      itemsToShow: 1,
      snapAlign: "center",
    },
    testimonials: [
      {
        id: 1,
        shortDesc:
          "“It is a long establish fact that reader will be distract by readable content of a page wher looking at its layout”",
        image: require("../../assets/images/testimonials/client-3.jpg"),
        name: "Jim Morison",
        designation: "Director, BAT",
      },
      {
        id: 2,
        shortDesc:
          "“It is a long establish fact that reader will be distract by readable content of a page wher looking at its layout”",
        image: require("../../assets/images/testimonials/client-2.jpg"),
        name: "Alex Cruis",
        designation: "CEO, IBAC",
      },
      {
        id: 3,
        shortDesc:
          "“It is a long establish fact that reader will be distract by readable content of a page wher looking at its layout”",
        image: require("../../assets/images/testimonials/client-3.jpg"),
        name: "Tom Haris",
        designation: "Engineer, Olleo",
      },
      {
        id: 4,
        shortDesc:
          "“It is a long establish fact that reader will be distract by readable content of a page wher looking at its layout”",
        image: require("../../assets/images/testimonials/client-4.jpg"),
        name: "Harry Jackson",
        designation: "Enterpreneur",
      },
      {
        id: 5,
        shortDesc:
          "“It is a long establish fact that reader will be distract by readable content of a page wher looking at its layout”",
        image: require("../../assets/images/testimonials/client-5.jpg"),
        name: "Will Smith",
        designation: "Engineer",
      },
    ],
    breakpoints: {
      0: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      768: {
        itemsToShow: 2,
        snapAlign: "start",
      },
      1200: {
        itemsToShow: 3,
        snapAlign: "center",
      },
      1400: {
        itemsToShow: 4,
        snapAlign: "start",
      },
    },
  }),
});
</script>